module.exports = __webpack_public_path__ + "static/media/elec.b783931b.png";